import {
  resolveBrowserHref,
  type BrowserRef,
} from 'volto-ministerio-publico-federal/components/View/CapaView/helpers';

export const ACEITE_TEXTO_PADRAO = 'Li e aceito os termos acima descritos';

export const ACEITE_BOTAO_PADRAO = 'Entrar com o GOV.BR';

export const ACEITE_AVISO_PADRAO = 'Aceite os termos antes de continuar';

export interface AceiteTermosData {
  '@type'?: string;
  textoCheckbox?: string;
  botaoRotulo?: string;
  href?: BrowserRef[];
  novaAba?: boolean;
  mensagemAviso?: string;
}

export interface AceiteTermos {
  texto: string;
  botaoRotulo: string;
  aviso: string;
  href?: string;
  novaAba: boolean;
}

const comPadrao = (valor: string | undefined, padrao: string): string =>
  valor?.trim() || padrao;

export const toAceiteTermos = (data?: AceiteTermosData): AceiteTermos => ({
  texto: comPadrao(data?.textoCheckbox, ACEITE_TEXTO_PADRAO),
  botaoRotulo: comPadrao(data?.botaoRotulo, ACEITE_BOTAO_PADRAO),
  aviso: comPadrao(data?.mensagemAviso, ACEITE_AVISO_PADRAO),
  href: resolveBrowserHref(data?.href),
  novaAba: Boolean(data?.novaAba),
});
